import { render, staticRenderFns } from "./StatisticsMarksByDepartmentGenderAgeView.vue?vue&type=template&id=63afaab4"
import script from "./StatisticsMarksByDepartmentGenderAgeView.vue?vue&type=script&lang=js"
export * from "./StatisticsMarksByDepartmentGenderAgeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports